export default __webpack_public_path__ + "static/testimonial-01-7851e6c82d5d37e7ee3b54de217ff278.png";